export default function () {
    return location?.href.substring(0, location?.href.lastIndexOf('/'));
}
